import { LogsService } from '@gtpl/shared-services/user-logs';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { Address } from './address.entity';
import { CustomersController } from './customers.controller';
import { Customers } from './customers.entity';
import { CustomersService } from './customers.service';
import { CustomersAdapter } from './dto/customers.adapter';

@Module({
  imports: [
    TypeOrmModule.forFeature([Customers,Address]),
  ],
  controllers: [CustomersController],
  providers: [CustomersService,CustomersAdapter,ApplicationExceptionHandler,LogsService]
})
export class CustomersModule {}
